import React, { FC } from 'react';

interface EventDescriptionAIStepsProps {
  step: number;
}

/**
 * Simple step display for description prompt modals
 *
 * @param param0
 * @returns
 */
const EventDescriptionAISteps: FC<React.PropsWithChildren<EventDescriptionAIStepsProps>> = ({
  step
}) => {
  /**
   * We will have this as 4.
   */

  return (
    <div>
      <div className="tw-font-normal tw-text-content-tertiary">Step {step} of 4</div>

      <div className="tw-mt-2 tw-flex">
        <div
          className={`tw-w-6  tw-rounded-sm tw-border-solid ${
            step >= 1 ? 'tw-border-primary-blue' : 'tw-border-border-grey'
          }`}
        />

        <div
          className={`tw-ml-1  tw-w-6 tw-rounded-sm tw-border-solid ${
            step >= 2 ? 'tw-border-primary-blue' : 'tw-border-border-grey'
          }`}
        />

        <div
          className={`tw-ml-1  tw-w-6 tw-rounded-sm tw-border-solid ${
            step >= 3 ? 'tw-border-primary-blue' : 'tw-border-border-grey'
          }`}
        />

        <div
          className={`tw-ml-1  tw-w-6 tw-rounded-sm tw-border-solid ${
            step >= 4 ? 'tw-border-primary-blue' : 'tw-border-border-grey'
          }`}
        />
      </div>
    </div>
  );
};

export default EventDescriptionAISteps;
